<template>
    <div class="eval_page">
        <h1>职业评估问卷</h1>
        <div class="eval_category">
            <div :class="info_windows_show[0]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="eval_options_list">
                    <button :class="is_hr_worker?is_hr_worker===1?'info_btn':'info_btn_selected':'info_btn'" :data-state="infos[0]['state']"
                            :data-id="infos[0]['id']" @click="click_btn($event)">
                        {{ infos[0]['info'] }}
                    </button>

                </div>
                <div class="eval_options_list">
                    <button :class="is_hr_worker?'info_btn':'info_btn_selected'" :data-state="infos[1]['state']" :data-id="infos[1]['id']"
                            @click="click_btn($event)">
                        {{ infos[1]['info'] }}
                    </button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[1]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="eval_options_flow">
                    <div class="eval_options_list_quarter" v-for="(info, index) in infos" :key="index">
                        <button :class="info['id'] === industry_selected['id']?'info_btn_selected': 'info_btn'" :data-state="info['state']"
                                :data-id="info['id']" @click="click_btn($event)">
                            {{ info['info'] }}
                        </button>
                    </div>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="1" @click="previous_step($event)">上一步</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[2]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">职位: </label>
                    <select class="form-control work_select" v-model="position">
                        <option v-for="(pos, index) in is_hr_worker?hr_positions:positions" :key="index" :value="pos['id']" :data-id="pos['id']">
                            {{ pos['name'] }}
                        </option>
                    </select>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">公司规模: </label>
                    <select class="form-control work_select" v-model="company_size">
                        <option value="大型">大型</option>
                        <option value="中型">中型</option>
                        <option value="小型">小型</option>
                        <option value="微型">微型</option>
                    </select>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">就职日期: </label>
                    <el-date-picker type="year" v-model="position_data"></el-date-picker>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">起始年薪: </label>
                    <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_start">
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">当前年薪: </label>
                    <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_now">
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">下属数量: </label>
                    <input type="text" class="form-control" v-model="subordinate_count">
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="2" @click="previous_step($event)">上一步</button>
                    <button class="save_button" data-id="2" @click="next_step($event)">下一步</button>
                </div>
                <div style="clear: both"></div>
                <!--<h2 class="question_label">{{ question_info }}</h2>-->
                <!--<div class="eval_options_list_half" v-for="(info, index) in infos" :key="index">-->
                <!--<button class="info_btn" :data-state="info['state']" :data-id="info['id']" @click="click_info_btn($event)">-->
                <!--{{ info['info'] }}-->
                <!--</button>-->
                <!--</div>-->
                <!--<div :class="step1?'main_info_layout_div ruby_div':'eval_btn_category_hide'">-->
                <!--<label class="main_info_label">就职日期: </label>-->
                <!--<el-date-picker type="year" data-id="2"  v-model="position_data"></el-date-picker>-->
                <!--</div>-->
                <!--<div class="eval_buttons_navi">-->
                <!--<button class="save_button" data-id="2" @click="previous_step($event)">上一步</button>-->
                <!--<button class="save_button" data-id="2" @click="next_step($event)">下一步</button>-->
                <!--</div>-->
                <!--<div style="clear: both"></div>-->
            </div>
            <div :class="info_windows_show[3]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="eval_options_list">
                    <button :class="is_first_work?is_first_work===1?'info_btn':'info_btn_selected':'info_btn'" :data-state="infos[0]['state']"
                            :data-id="infos[0]['id']" @click="click_btn($event)">
                        {{ infos[0]['info'] }}
                    </button>
                </div>
                <div class="eval_options_list">
                    <button :class="is_first_work?'info_btn':'info_btn_selected'" :data-state="infos[1]['state']" :data-id="infos[1]['id']"
                            @click="click_btn($event)">
                        {{ infos[1]['info'] }}
                    </button>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="3" @click="previous_step($event)">上一步</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[4]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="eval_options_list">
                    <button :class="is_first_hr_worker?is_first_hr_worker===1?'info_btn':'info_btn_selected':'info_btn'"
                            :data-state="infos[0]['state']" :data-id="infos[0]['id']" @click="click_btn($event)">
                        {{ infos[0]['info'] }}
                    </button>

                </div>
                <div class="eval_options_list">
                    <button :class="is_first_hr_worker?'info_btn':'info_btn_selected'" :data-state="infos[1]['state']" :data-id="infos[1]['id']"
                            @click="click_btn($event)">
                        {{ infos[1]['info'] }}
                    </button>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="4" @click="previous_step($event)">上一步</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[5]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="eval_options_list_quarter" v-for="(info, index) in infos" :key="index">
                    <button :class="info['id'] === first_industry_type['id']?'info_btn_selected': 'info_btn'" :data-state="info['state']"
                            :data-id="info['id']" @click="click_btn($event)">
                        {{ info['info'] }}
                    </button>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="5" @click="previous_step($event)">上一步</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[6]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">职位: </label>
                    <select class="form-control work_select" v-model="first_position">
                        <option v-for="(pos, index) in is_first_hr_worker?hr_positions:positions" :key="index" :value="pos['id']"
                                :data-id="pos['id']">
                            {{ pos['name'] }}
                        </option>
                    </select>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">公司规模: </label>
                    <select class="form-control work_select" v-model="first_company_size">
                        <option value="大型">大型</option>
                        <option value="中型">中型</option>
                        <option value="小型">小型</option>
                        <option value="微型">微型</option>
                    </select>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">就职日期: </label>
                    <el-date-picker type="year" v-model="first_position_data"></el-date-picker>
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">当时年薪: </label>
                    <input placeholder="人民币：圆" type="text" class="form-control" v-model="first_salary_now">
                </div>
                <div class="main_info_layout_div info_position">
                    <label class="main_info_label">下属数量: </label>
                    <input type="text" class="form-control" v-model="first_subordinate_count">
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="6" @click="previous_step($event)">上一步</button>
                    <button class="save_button" data-id="6" @click="next_step($event)">下一步</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <div :class="info_windows_show[7]? 'eval_btn_category': 'eval_btn_category_hide'">
                <h2 class="question_label">{{ question_info }}</h2>
                <div class="main_info_layout_div">
                    <div class="eval_options_list_quarter" v-for="(info, index) in infos" :key="index">
                        <button :class="info['id'] === education?'info_btn_selected': 'info_btn'" :data-state="info['state']" :data-id="info['id']" @click="click_edu_btn($event)">
                            {{ info['info'] }}
                        </button>
                    </div>
                </div>
                <div :class="step1?'main_info_layout_div ruby_div':'eval_btn_category_hide'">
                    <label class="main_info_label">出生日期: </label>
                    <el-date-picker id="test" type="year" data-id="8" v-model="birth_data"></el-date-picker>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" data-id="7" @click="previous_step($event)">上一步</button>
                    <button :class="step1?'save_button':'eval_btn_category_hide'" data-id="7" @click="save_position_info($event)">完成评估</button>
                </div>
                <div style="clear: both"></div>
            </div>
            <!--<div :class="info_windows_show[8]? 'eval_btn_category': 'eval_btn_category_hide'">-->

            <!--<div style="clear: both"></div>-->
            <!--</div>-->
            <div :class="rate_show?'eval_rate_div_show div_block': 'eval_rate_div_hide'">
                <br>
                <div style="margin: auto">
                    <table border="1" class="rate_table">
                        <tr>
                            <th>序号</th>
                            <th>评估分析内容</th>
                            <th>获得现职位时排名</th>
                            <th>现职位目前排名</th>
                            <th>排名变动</th>
                        </tr>
                        <tr v-for="(rate, index) in rate_data['line_1']" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{table_1_column[index]}}</td>
                            <td>{{rate['rate']}}</td>
                            <td>{{rate_data['line_2'][index]['rate']}}</td>
                            <td></td>
                        </tr>
                    </table>
                </div>
                <hr>
                <div style="margin: auto">
                    <table border="1" class="rate_table">
                        <tr>
                            <th>序号</th>
                            <th>评估分析内容</th>
                            <th>获得现职位时排名</th>
                            <th>现职位目前排名</th>
                            <th>排名变动</th>
                        </tr>
                        <tr v-for="(rate, index) in rate_data['line_3']" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{table_2_column[index]}}</td>
                            <td>{{rate['rate']}}</td>
                            <td>{{rate_data['line_4'][index]['rate']}}</td>
                            <td></td>
                        </tr>
                    </table>
                </div>

                <!--<div class="main_info_rate_layout_div">-->
                <!--<div class="main_info_rate_layout_div_in info_position"-->
                <!--v-for="(rate, index) in rate_data['line_1']"-->
                <!--:key="index">-->
                <!--<label class="main_info_rate_label"> {{ rate['name'] }} </label>-->
                <!--<p class="main_info_rate_value_label"> {{ rate['rate'] }} </p>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="main_info_rate_layout_div">-->
                <!--<div class="main_info_rate_layout_div_in info_position"-->
                <!--v-for="(rate, index) in rate_data['line_2']"-->
                <!--:key="index">-->
                <!--<label class="main_info_rate_label"> {{ rate['name'] }} </label>-->
                <!--<p class="main_info_rate_value_label"> {{ rate['rate'] }} </p>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="main_info_rate_layout_div">-->
                <!--<div class="main_info_rate_layout_div_in info_position"-->
                <!--v-for="(rate, index) in rate_data['line_3']"-->
                <!--:key="index">-->
                <!--<label class="main_info_rate_label"> {{ rate['name'] }} </label>-->
                <!--<p class="main_info_rate_value_label"> {{ rate['rate'] }} </p>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="main_info_rate_layout_div">-->
                <!--<div class="main_info_rate_layout_div_in info_position"-->
                <!--v-for="(rate, index) in rate_data['line_4']"-->
                <!--:key="index">-->
                <!--<label class="main_info_rate_label"> {{ rate['name'] }} </label>-->
                <!--<p class="main_info_rate_value_label"> {{ rate['rate'] }} </p>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'
    // import laydate from 'laydate'

    export default {
        data: function () {
            return {
                table_1_column: ['职位的年龄排名', '所属行业中的年龄排名', '管理下属数量排名', '所在企业规模排名', '同学历中的年龄排名'],
                table_2_column: ['同行业同职位薪资排名', '同年龄薪资排名', '同职位薪资排名', '同等规模企业薪资排名', '同学历中的薪资排名'],
                position: '',
                first_position: '',
                first_position_line: '',
                education: '',
                salary_start: '',
                first_salary_start: '',
                salary_now: '',
                first_salary_now: '',
                subordinate_count: '',
                first_subordinate_count: '',
                company_size: '',
                first_company_size: '',
                position_data: '',
                first_position_data: '',
                birth_data: '',
                step1: false,
                step2: false,
            }
        },
        methods: {
            ...mapActions({
                set_start_btn_infos: 'eval_position/set_state_btn_info',
                click_btn_js: 'eval_position/click_btn',
                save_info: 'eval_position/save_info',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class',
                previous_step_js: 'eval_position/previous_step',
                next_step_js: 'eval_position/next_step',
                set_window_4_info: 'eval_position/set_window_4_info',
            }),
            click_btn: function (event) {
                let state = event.target.getAttribute('data-state')
                let id = event.target.getAttribute('data-id')
                if (state === '4') {
                    if (id === '0') {
                        this.first_position = this.first_position_line[1]
                    } else {
                        this.first_position = this.first_position_line[0]
                    }
                } else if (state === '0') {
                    if (id === '0') {
                        this.position = this.position_line[1]
                    } else {
                        this.position = this.position_line[0]
                    }
                }
                console.log(this.position, this.position_line, id, state, this.is_hr_worker, 'test')
                this.click_btn_js(event)
            },
            save_position_info: function () {
                let obj = {
                    'position': this.position,
                    'first_position': this.first_position,
                    'education': this.education,
                    'salary_start': this.salary_start,
                    'first_salary_start': this.first_salary_start,
                    'salary_now': this.salary_now,
                    'first_salary_now': this.first_salary_now,
                    'subordinate_count': this.subordinate_count,
                    'first_subordinate_count': this.first_subordinate_count,
                    'company_size': this.company_size,
                    'first_company_size': this.first_company_size,
                    'position_data': this.position_data,
                    'first_position_data': this.first_position_data,
                    'birth_data': this.birth_data,
                }
                let that = this
                this.save_info(obj).then(function (val) {
                    console.log(val.data.result)
                    that.$router.push({name: 'eval_state'})
                })
            },
            click_info_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.position = Number(event.target.getAttribute('data-id'))
                this.step1 = true
            },
            click_edu_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.education = Number(event.target.getAttribute('data-id'))
                this.step1 = true
            },
            click_cs_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.company_size = Number(event.target.getAttribute('data-id'))
                this.step1 = true
            },
            previous_step: function (event) {
                this.step1 = false
                this.step2 = false
                // let id = event.target.getAttribute('data-id')
                // if (id === '1'){
                //     // let target = event.target.parentNode.parentNode.childNodes
                //     let target = event.target.parentNode.parentNode.previousSibling.childNodes
                //     console.log(target.length,event.target,target[1].firstChild, 'target')
                //     target[1].firstChild.focus()
                //     for (let i=0; i<target.length;i++){
                //         if (target[i].className === 'eval_options_list'){
                //             console.log(target[i].firstChild)
                //         }
                //     }
                // }
                this.previous_step_js(event)
            },
            next_step: function (event) {
                this.step1 = false
                this.step2 = false
                let that = this
                let id = event.target.getAttribute('data-id')
                if (id === '2') {
                    if(!this.position_data){
                        alert('请填写就职日期')
                    }else{
                        this.set_window_4_info([this.position_data, this.position]).then(function () {
                            that.next_step_js(event)
                        })
                    }
                } else {
                    this.next_step_js(event)
                }
            }
        },
        computed: {
            ...mapState({
                infos: state => state.eval_position.infos,
                info_box_show: state => state.eval_position.info_box_show,
                info_select_show: state => state.eval_position.info_select_show,
                rate_show: state => state.eval_position.rate_show,
                positions: state => state.eval_position.positions,
                hr_positions: state => state.eval_position.hr_positions,
                educations: state => state.eval_position.educations,
                industries: state => state.eval_position.industries,
                rate_data: state => state.eval_position.rate_data,
                user_info: state => state.eval_position.user_info,
                question_info: state => state.eval_position.question_info,
                info_windows_show: state => state.eval_position.info_windows_show,
                is_first_hr_worker: state => state.eval_position.is_first_hr_worker,
                is_hr_worker: state => state.eval_position.is_hr_worker,
                first_industry_type: state => state.eval_position.first_industry_type,
                industry_selected: state => state.eval_position.industry_selected,
                is_first_work: state => state.eval_position.is_first_work,
            })
        },
        mounted: function () {
            let that = this
            this.set_start_btn_infos().then(function () {
                that.position = that.user_info['position']
                that.position_line = [that.user_info['position'], that.user_info['position_line']]
                that.education = that.user_info['education']
                that.salary_start = that.user_info['salary_start']
                that.salary_now = that.user_info['salary_now']
                that.subordinate_count = that.user_info['subordinate_count']
                that.company_size = that.user_info['company_size']
                that.position_data = that.user_info['position_data']
                that.birth_data = that.user_info['birth_data']
                that.first_position = that.user_info['first_position']
                that.first_position_line = [that.user_info['first_position'], that.user_info['first_position_line']]
                that.first_salary_start = that.user_info['first_salary_start']
                that.first_salary_now = that.user_info['first_salary_now']
                that.first_subordinate_count = that.user_info['first_subordinate_count']
                that.first_company_size = that.user_info['first_company_size']
                that.first_position_data = that.user_info['first_position_data']
            })
            localStorage.setItem('field', '')
            // console.log(laydate)
            // laydate.render({
            //   elem: '#test',
            //   done: (value) => {
            //     this.date = value
            //   }
            // })
        }
    }

</script>
<style type="text/css">
    .eval_page {
        width: 1170px;
        height: 100%;
        margin: auto;
        padding: 16px;
    }

    .eval_page > h1 {
        padding-left: 72px;
        color: #fff;
    }

    .eval_category {
        text-align: center;
        width: 1000px;
        margin: 8px auto;
        padding: 16px 0;
        background: #fff 50%;
        min-height: 540px;
        border: #3e83c5 1px;
        border-radius: 10px;
    }

    .eval_options_list {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        /*float: left;*/
    }

    .eval_options_list_half {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        width: 50%;
        float: left;
    }

    .eval_options_list_quarter {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        width: 25%;
        float: left;
    }

    .save_button {
        margin-left: 50px;
        margin-right: 50px;
        color: #fff;
        border-color: #66CCFF;
        background-color: #66CCFF;
        border: 1px solid transparent;
        padding: .375rem 2rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .save_button:hover {
        color: #fff;
        border-color: #068e6c;
        background-color: #068e6c;
    }

    .main_info_layout_div {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
    }

    .ruby_div {
        display: ruby;
    }

    .eval_options_flow {
        display: flow-root;
    }

    .eval_buttons_navi {
        display: inline-block;
        align-items: center;
        position: relative;
        margin: 20px;
    }

    .eval_buttons_navi > button {
        border-radius: 22px;
    }

    .main_info_rate_layout_div {
        display: inline;
        width: 25%;
        align-items: center;
        /*position: relative;*/
        margin-bottom: 20px;
    }

    .main_info_rate_layout_div_in {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
    }

    .main_info_label {
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        font-size: 1rem;
        line-height: 1.5;
        max-width: 16.66666%;
        flex: 0 0 16.6666%;
    }

    .question_label {
        font-size: 1.5rem;
        min-height: 3rem;
    }

    .main_info_rate_label {
        white-space: nowrap;
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        font-size: 1rem;
        line-height: 1.5;
        width: 80%;
        flex: 0 0 16.6666%;
    }

    .main_info_rate_value_label {
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        float: right;
        font-size: 1rem;
        line-height: 1.5;
        width: 20%;
        flex: 0 0 16.6666%;
    }

    .work_select :after {
        content: "333";
        width: 1rem;
        height: 1rem;
        position: absolute;
    }

    .work_select {
        appearance: none;
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center/8px 10px;
    }

    .eval_options_list_hide {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 40px;
        display: none;
    }

    .info_btn {
        background: #dde6eb;
        background-image: -webkit-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -moz-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -ms-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -o-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: linear-gradient(to bottom, #dde6eb, #b0c1cc);
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        font-family: Arial;
        color: #ffffff;
        font-size: 20px;
        padding: 6px 15px 6px 15px;
        border: solid #acc9e5 1px;
        min-width: 120px;
        text-decoration: none;
    }

    .info_btn:hover {
        background: #2980b9;
        background-image: -webkit-linear-gradient(top, #2980b9, #3498db);
        background-image: -moz-linear-gradient(top, #2980b9, #3498db);
        background-image: -ms-linear-gradient(top, #2980b9, #3498db);
        background-image: -o-linear-gradient(top, #2980b9, #3498db);
        background-image: linear-gradient(to bottom, #2980b9, #3498db);
        color: #ffffff;
        text-decoration: none;
    }

    .info_btn:focus {
        background: #69c060;
        background-image: -webkit-linear-gradient(top, #69c060, #74d688);
        background-image: -moz-linear-gradient(top, #69c060, #74d688);
        background-image: -ms-linear-gradient(top, #69c060, #74d688);
        background-image: -o-linear-gradient(top, #69c060, #74d688);
        background-image: linear-gradient(to bottom, #69c060, #74d688);
        color: #ffffff;
        text-decoration: none;
    }

    .info_btn_selected {
        background: #69c060;
        background-image: -webkit-linear-gradient(top, #69c060, #74d688);
        background-image: -moz-linear-gradient(top, #69c060, #74d688);
        background-image: -ms-linear-gradient(top, #69c060, #74d688);
        background-image: -o-linear-gradient(top, #69c060, #74d688);
        background-image: linear-gradient(to bottom, #69c060, #74d688);
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        font-family: Arial;
        color: #ffffff;
        font-size: 20px;
        padding: 6px 15px 6px 15px;
        border: solid #acc9e5 1px;
        min-width: 120px;
        text-decoration: none;
    }

    .eval_box_div_show {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 30%;
    }

    .eval_box_div_hide {
        display: none;
    }

    .eval_rate_div_show {
        display: flex;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
    }

    .eval_rate_div_hide {
        display: none;
    }

    .eval_btn_category {
        display: block;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
    }

    .eval_btn_category_hide {
        display: none;
    }

    .skill_category_title {
        font-size: 16px;
        color: #666;
        width: 62px;
        min-width: 62px;
        margin-top: 2px;
    }

    .skill_category {
        width: 1170px;
        padding: 0 5px;
        margin-left: auto;
        margin-right: auto;
    }

    .skill_category_div {
        width: 100%;
        background: #fff;
        padding: 20px;
        border: 1px solid #eee;
        margin-bottom: 10px;
    }

    .skill_selection {
        display: flex;
        margin-bottom: 10px;
        /*flex-wrap: wrap;*/
    }

    .skill_category_tag {
        /*border-bottom: 2px solid #eee;*/
        /*margin-bottom: 0;*/
        /*padding-bottom: 10px;*/
    }

    .skill_selection_card {
        display: flex;
        flex-wrap: wrap;
    }

    .libary_main_libray_content_cards {
        display: flex;
        flex-wrap: wrap;
        background: #fff;
    }

    .libary_main_libray_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .libray_main_library_content_card {
        width: 33%;
        padding: 10px 15px;
    }

    .complete {
        padding: .375rem .5rem;
        color: #fff;
        background: #66CCFF;
        border: 1px solid #59C0F0;
        width: 100px;
        font-size: 1rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .rate_table {
        border-collapse: collapse;
        text-align: center;
        table-layout: fixed;
        width: 1000px;
        margin-left: auto;
        margin-right: auto;
    }

    .div_block {
        display: block;
    }

</style>
